var map = {
	"./awards-carousel": [
		"./src/js/modules/awards-carousel.js",
		"swiper",
		"awards-carousel"
	],
	"./awards-carousel-sidebar": [
		"./src/js/modules/awards-carousel-sidebar.js",
		"swiper",
		"awards-carousel-sidebar"
	],
	"./awards-carousel-sidebar.js": [
		"./src/js/modules/awards-carousel-sidebar.js",
		"swiper",
		"awards-carousel-sidebar"
	],
	"./awards-carousel.js": [
		"./src/js/modules/awards-carousel.js",
		"swiper",
		"awards-carousel"
	],
	"./ebook-about": [
		"./src/js/modules/ebook-about.js",
		"swiper",
		"ebook-about"
	],
	"./ebook-about.js": [
		"./src/js/modules/ebook-about.js",
		"swiper",
		"ebook-about"
	],
	"./ebook-carousel": [
		"./src/js/modules/ebook-carousel.js",
		"swiper",
		"ebook-carousel"
	],
	"./ebook-carousel.js": [
		"./src/js/modules/ebook-carousel.js",
		"swiper",
		"ebook-carousel"
	],
	"./fifth-section-videos-carousel": [
		"./src/js/modules/fifth-section-videos-carousel.js",
		"swiper",
		"fifth-section-videos-carousel"
	],
	"./fifth-section-videos-carousel.js": [
		"./src/js/modules/fifth-section-videos-carousel.js",
		"swiper",
		"fifth-section-videos-carousel"
	],
	"./fourth-section-carousel": [
		"./src/js/modules/fourth-section-carousel.js",
		"swiper",
		"fourth-section-carousel"
	],
	"./fourth-section-carousel.js": [
		"./src/js/modules/fourth-section-carousel.js",
		"swiper",
		"fourth-section-carousel"
	],
	"./hero-videos-carousel": [
		"./src/js/modules/hero-videos-carousel.js",
		"swiper",
		"hero-videos-carousel"
	],
	"./hero-videos-carousel.js": [
		"./src/js/modules/hero-videos-carousel.js",
		"swiper",
		"hero-videos-carousel"
	],
	"./podcast-episodes-carousel": [
		"./src/js/modules/podcast-episodes-carousel.js",
		"swiper",
		"podcast-episodes-carousel"
	],
	"./podcast-episodes-carousel.js": [
		"./src/js/modules/podcast-episodes-carousel.js",
		"swiper",
		"podcast-episodes-carousel"
	],
	"./podcast-playlist-carousel": [
		"./src/js/modules/podcast-playlist-carousel.js",
		"swiper",
		"podcast-playlist-carousel"
	],
	"./podcast-playlist-carousel.js": [
		"./src/js/modules/podcast-playlist-carousel.js",
		"swiper",
		"podcast-playlist-carousel"
	],
	"./podcast-recent-episodes-carousel": [
		"./src/js/modules/podcast-recent-episodes-carousel.js",
		"swiper",
		"podcast-recent-episodes-carousel"
	],
	"./podcast-recent-episodes-carousel.js": [
		"./src/js/modules/podcast-recent-episodes-carousel.js",
		"swiper",
		"podcast-recent-episodes-carousel"
	],
	"./podcast-section-carousel": [
		"./src/js/modules/podcast-section-carousel.js",
		"swiper",
		"podcast-section-carousel"
	],
	"./podcast-section-carousel.js": [
		"./src/js/modules/podcast-section-carousel.js",
		"swiper",
		"podcast-section-carousel"
	],
	"./podcast-sidebar-carousel": [
		"./src/js/modules/podcast-sidebar-carousel.js",
		"swiper",
		"podcast-sidebar-carousel"
	],
	"./podcast-sidebar-carousel.js": [
		"./src/js/modules/podcast-sidebar-carousel.js",
		"swiper",
		"podcast-sidebar-carousel"
	],
	"./results-carousel": [
		"./src/js/modules/results-carousel.js",
		"swiper",
		"results-carousel"
	],
	"./results-carousel.js": [
		"./src/js/modules/results-carousel.js",
		"swiper",
		"results-carousel"
	],
	"./results-slider-sidebar": [
		"./src/js/modules/results-slider-sidebar.js",
		"swiper",
		"results-slider-sidebar"
	],
	"./results-slider-sidebar.js": [
		"./src/js/modules/results-slider-sidebar.js",
		"swiper",
		"results-slider-sidebar"
	],
	"./stories-video-carousel": [
		"./src/js/modules/stories-video-carousel.js",
		"swiper",
		"stories-video-carousel"
	],
	"./stories-video-carousel.js": [
		"./src/js/modules/stories-video-carousel.js",
		"swiper",
		"stories-video-carousel"
	],
	"./team-carousel": [
		"./src/js/modules/team-carousel.js",
		"swiper",
		"team-carousel"
	],
	"./team-carousel.js": [
		"./src/js/modules/team-carousel.js",
		"swiper",
		"team-carousel"
	],
	"./team-sidebar-widget": [
		"./src/js/modules/team-sidebar-widget.js",
		"swiper",
		"team-sidebar-widget"
	],
	"./team-sidebar-widget.js": [
		"./src/js/modules/team-sidebar-widget.js",
		"swiper",
		"team-sidebar-widget"
	],
	"./testimonials-carousel": [
		"./src/js/modules/testimonials-carousel.js",
		"swiper",
		"testimonials-carousel"
	],
	"./testimonials-carousel-sidebar": [
		"./src/js/modules/testimonials-carousel-sidebar.js",
		"swiper",
		"testimonials-carousel-sidebar"
	],
	"./testimonials-carousel-sidebar.js": [
		"./src/js/modules/testimonials-carousel-sidebar.js",
		"swiper",
		"testimonials-carousel-sidebar"
	],
	"./testimonials-carousel.js": [
		"./src/js/modules/testimonials-carousel.js",
		"swiper",
		"testimonials-carousel"
	],
	"./videos-carousel": [
		"./src/js/modules/videos-carousel.js",
		"swiper",
		"videos-carousel"
	],
	"./videos-carousel.js": [
		"./src/js/modules/videos-carousel.js",
		"swiper",
		"videos-carousel"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/js/modules lazy recursive ^\\.\\/.*$";
module.exports = webpackAsyncContext;